import DualloTenantClient from "@/clients/duallo/DualloOrganizationClient";
import { useOrganizationStore } from "@/store/organizationStore";

class organizationSaSService {

    constructor() {
        this.sasToken = null;
        this.sasUri = null;
        this.expiresAt = null;
        this.pendingRefresh = null;
        this.refreshBufferMs = 10 * 60 * 1000;

        this.tenantStore = null;
        this.tenantId = null;
    }

    async getSignedUrl(stableUrl) {
        if (!stableUrl) return null;

        if (this.tenantStore == null) this.updateTenant();

        await this.ensureValidToken();

        // The baked-model path carries a cache-bust marker (…{scanId}.ply?v={bakedAt}), so stableUrl may
        // already have a query string. The SAS token starts with "?"; appending it verbatim would make a
        // second "?" and Azure folds "sv" into the previous param's value → signature mismatch (403).
        // Join with "&" when there's already a query string, normalising the token's leading separator.
        const sas = this.sasToken.replace(/^[?&]/, "");
        const separator = stableUrl.includes("?") ? "&" : "?";
        return `${this.sasUri}${stableUrl}${separator}${sas}&t=${Date.now()}`
    }

    updateTenant(){
        this.tenantStore = useOrganizationStore();
        this.tenantId = this.tenantStore.organizationId;
    }

    async ensureValidToken() {
        if (this.hasValidToken()) {
            return;
        }

        if (this.pendingRefresh) {
            await this.pendingRefresh;
            return;
        }

        this.pendingRefresh = await this.fetchTokenFromApi(this.tenantId)
            .then((result) => {
                this.sasUri = result.root;
                this.sasToken = result.token;
                this.expiresAt = new Date(result.expiresOn).getTime();
            })
            .finally(() => {
                this.pendingRefresh = null;
            });

        await this.pendingRefresh;
    }

    hasValidToken() {
        if (!this.sasToken || !this.expiresAt) {
            return false;
        }

        const now = Date.now();
        return now < (this.expiresAt - this.refreshBufferMs);
    }

    async fetchTokenFromApi(tenantId) {
        return await DualloTenantClient.getSasTokenData(tenantId);
    }

    clear() {
        this.sasUri = null;
        this.sasToken = null;
        this.expiresAt = null;
        this.pendingRefresh = null;
    }
}

export default new organizationSaSService();